import { render, staticRenderFns } from "./StudentView.vue?vue&type=template&id=5e0074f8&"
import script from "./StudentView.vue?vue&type=script&lang=js&"
export * from "./StudentView.vue?vue&type=script&lang=js&"
import style0 from "./StudentView.vue?vue&type=style&index=0&lang=css&"
import style1 from "./StudentView.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports